import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Landing from "./pages/Landing";
import LoginPage from "./pages/Login";
import CloneList from "./pages/CloneList";
import AddNewClone from "./pages/AddNewClone";
import UserProfile from "./pages/UserProfile";
import Register from "./pages/Register";
import CloneFamilyTree from "./pages/CloneFamilyTree";
import EditClone from "./pages/EditClone";
import Chat from "./pages/Chat";
import { ToastContainer } from "react-toastify";
import AddMemory from "./pages/AddMemory";
import EditMemory from "./pages/EditMemory";
import Memory from "./pages/Memory";
import UserList from "./pages/dashboard/UserList";
import PricingPage from "./pages/Pricing";
import SubscriptionExpired from "./pages/SubscriptionExpired";
import Private from "./components/routes/Private";
import EarningList from "./pages/dashboard/EarningList";
import EditUser from "./pages/dashboard/EditUser";
import SubscriptionList from "./pages/dashboard/SubscriptionList";
import EditSubscription from "./pages/dashboard/EditSubscription";
import OrderList from "./pages/dashboard/OrderList";
import CloneDashList from "./pages/dashboard/CloneList";
import EditOrders from "./pages/dashboard/EditOrders";
import Checkout from "./pages/Checkout";
import AlertPage from "./pages/AlertPage";
import OnSubscription from "./components/routes/OnSubscription";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Navigate to="/" />} />
        <Route exact path="/login" element={<LoginPage />} />
        <Route exact path="/sign-up" element={<Register />} />
        <Route exact path="/forgot-password" element={<ForgotPassword/>} />
        <Route exact path="/reset-password" element={<ResetPassword/>} />

        <Route exact path="/clone-list" element={<Private><CloneList /></Private>} />
        <Route exact path="/add-clone" element={<Private><AddNewClone /></Private>} />
        <Route exact path="/edit-clone/:id" element={<Private><EditClone /></Private>} />
        <Route exact path="/profile" element={<Private><UserProfile /></Private>} />
        <Route exact path="/family-tree/:id" element={<Private><CloneFamilyTree /></Private>} />
        <Route exact path="/chat/:id" element={<Private><OnSubscription><Chat /></OnSubscription></Private>} />
        <Route exact path="/chat" element={<Private><OnSubscription><Chat /></OnSubscription></Private>} />
        <Route exact path="/add-memory/:id" element={<Private><AddMemory /></Private>} />
        <Route exact path="/memory/:id" element={<Private><Memory /></Private>} />
        <Route exact path="/edit-memory/:id" element={<Private><EditMemory /></Private>} />

        <Route exact path="/pricing" element={<Private><PricingPage /></Private>}/>

        <Route exact path="/dashboard/total-earnings" element={<Private adminOnly><EarningList /></Private>} />

        <Route exact path="/dashboard/user/list" element={<Private adminOnly><UserList /></Private>} />
        <Route exact path="/dashboard/user/add" element={<Private adminOnly><EditUser /></Private>} />
        <Route exact path="/dashboard/user/:id" element={<Private adminOnly><EditUser /></Private>} />

        <Route exact path="/dashboard/clone/list" element={<Private adminOnly><CloneDashList /></Private>} />

        <Route exact path="/dashboard/subscriptions/list" element={<Private adminOnly><SubscriptionList /></Private>} />
        <Route exact path="/dashboard/subscription/add" element={<Private adminOnly><EditSubscription /></Private>} />
        <Route exact path="/dashboard/subscription/edit/:id" element={<Private adminOnly><EditSubscription /></Private>} />

        <Route exact path="/dashboard/orders/list" element={<Private adminOnly><OrderList /></Private>} />
        <Route exact path="/dashboard/orders/add" element={<Private adminOnly><EditOrders /></Private>} />
        <Route exact path="/dashboard/orders/:id" element={<Private adminOnly><EditOrders /></Private>} />

        <Route exact path="/checkout/:id" element={<Private><Checkout /></Private>} />

        <Route exact path="/subscription-expired" element={<Private><SubscriptionExpired /></Private>} />
        <Route exact path="/alert" element={<AlertPage />} />

      </Routes>
    </Router>
  );
}

export default App;
